import React from 'react';
import { LifeBuoyIcon } from 'lucide-react';

/* The last thing on the page, on purpose: it is the last thing a customer
   needs. No contact button, because there is no verified support address in
   this project — replying to the order email always reaches us. */
export function SupportCard() {
  return <section aria-labelledby="support-heading" className="px-5 pb-16 pt-4 sm:px-8" data-id="element-264" data-mp="eyktzauh9yru">
      <div className="mx-auto max-w-portal" data-id="element-265" data-mp="j0fs66h43w1e">
        <div className="flex flex-col gap-4 rounded-[18px] bg-mist p-6 sm:flex-row sm:items-start sm:gap-5 sm:p-8" data-id="element-266" data-mp="izo5xm9enans">
          <LifeBuoyIcon aria-hidden="true" className="h-7 w-7 shrink-0 text-navy" strokeWidth={2} data-id="element-267" data-mp="o13on7o41530" />
          <div data-id="element-268" data-mp="xxgl2db1hx1g">
            <h2 id="support-heading" className="font-display text-[22px] font-semibold leading-tight text-navy sm:text-[25px]" data-id="element-269" data-mp="xvvqwosn0g44">
              Need help with your order?
            </h2>
            <p className="mt-2 max-w-[40rem] font-sans text-[15.5px] leading-relaxed text-navy/75" data-id="element-270" data-mp="2zqnyfh73e4kp">
              Trouble accessing your books or want to request a refund? We’re here to help.
            </p>
            <p className="mt-3 max-w-[40rem] font-sans text-[14.5px] leading-relaxed text-navy/60" data-id="element-271" data-mp="23hc4p4jrtpy4">
              Reply to your order confirmation email with your order number and tell us what
              happened.
            </p>
          </div>
        </div>
      </div>
    </section>;
}